import { IResource } from "../interface/IResource";
import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum ResourceServiceEnum {
  getResource = "",
  save = "",
  delete = "?resourceId=",
  getById = "/"
}

export default class ResourceService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/resource");
  }

  public getResource = async (): Promise<IResource[]> => await this.GET(ResourceServiceEnum.getResource);
  public save = async (data: IResource): Promise<IResource> => await this.POST(ResourceServiceEnum.getResource, data);
  public delete = async (id: number) => await this.DELETE(ResourceServiceEnum.delete + id);
  public getById = async (id: number): Promise<any> => await this.GET(ResourceServiceEnum.getById + id);
}
